import { DoseSpotPharmacy } from '@abiglobalhealth/go-types'

import { Location } from '@/components/icons/Location'

interface PharmacyCardProps {
  pharmacy: DoseSpotPharmacy
  onClick: (_: DoseSpotPharmacy) => void
  isSelected?: boolean
}

const getAddress = (pharmacy: DoseSpotPharmacy) => {
  if (!pharmacy.addressl2) return pharmacy.address
  return [pharmacy.address, pharmacy.addressl2].join(',')
}

export const PharmacyCard = ({ pharmacy, onClick, isSelected }: PharmacyCardProps) => {
  return (
    <button
      className={`animate-fade-in hover:bg-primary-light flex w-full cursor-pointer flex-col gap-2 rounded-[5px] border p-3 transition-[color,border-color] ${isSelected ? 'border-primary bg-primary-light' : 'border-transparent bg-white'}`}
      onClick={() => onClick(pharmacy)}
    >
      <label className="w-fit font-bold">{pharmacy.name}</label>
      <div className="flex items-center gap-3">
        <Location customClassName="text-primary h-5 min-w-[13px]" />
        <div className="flex flex-col text-start">
          <label className="text-gray-text text-sm">{getAddress(pharmacy)}</label>
          <label className="text-gray-text text-sm">
            {[pharmacy.city, pharmacy.state].join(', ')} {pharmacy.zipCode}
          </label>
        </div>
      </div>
    </button>
  )
}
